import React, { Component } from "react";
import MDSpinner from "react-md-spinner";
import { DateTime } from "luxon";
import "./LoginPage.css";
import {
  loginContainerTransition,
  pageTransitionDuration,
} from "../../Util/animations/Animations";
// import handleError from '../../Util/HandleError'
// import displayNotification from '../../Util/DisplayNotification'
import { AppContext } from "../../Util/contexts/AppContext";
import FAQText from "./FAQText";

export default class LoginPage extends Component {
  constructor() {
    super();
    this.state = {
      email: "",
      password: "",
      newEmail: "",
      confirmNewEmail: "",
      firstName: "",
      lastName: "",
      heard: "Google Search",
      page: "login",
      fetchOutstanding: false,
      loginErrorText: "",
      systemMessage: "",
      successMessage: "",
      doctorImages: [],
      currentImageIndex: 0,
      imageLoaded: false,
    };
    this.imageTimer = null;
  }

  static contextType = AppContext;

  componentDidMount() {
    this.fetchSystemMessage();
    this.loadDoctorImages();
    this.startImageRotation();

    var metaThemeColor = document.querySelector("meta[name=theme-color]");
    metaThemeColor.setAttribute("content", this.context.primaryColor);
  }

  componentWillUnmount() {
    if (this.imageTimer) {
      clearInterval(this.imageTimer);
    }
  }

  loadDoctorImages = () => {
    try {
      // Use webpack's require.context to dynamically import all images from doctors folder
      const imageContext = require.context(
        "../../Assets/doctors",
        false,
        /\.(png|jpe?g|svg)$/
      );
      let images = imageContext.keys().map(imageContext);

      const filtered = images.filter((image) => !image.includes("Doctor1"));
      const doctor1 = images.filter((image) => image.includes("Doctor1"));

      images = [...doctor1, ...filtered];
      if (images.length > 0) {
        this.setState({
          doctorImages: images,
          imageLoaded: true,
        });
      } else {
        // Fallback to a default image if no images found
        console.warn("No images found in /Assets/doctors folder");
        // You might want to set a default image here
      }
    } catch (error) {
      console.error("Error loading doctor images:", error);
      // Handle the error case - maybe set a default image
    }
  };

  startImageRotation = () => {
    // Change image every 4 seconds
    this.imageTimer = setInterval(() => {
      this.setState((prevState) => ({
        currentImageIndex:
          (prevState.currentImageIndex + 1) % prevState.doctorImages.length,
      }));
    }, 4000);
  };

  fetchSystemMessage = () => {
    let systemMessage = "";
    if (process.env.REACT_APP_ENABLE_LANDING_MESSAGE === "true") {
      fetch(`${this.context.route}/announcementnew.webapi`, {
        method: "GET",
      })
        .then((response) => {
          const decoder = new TextDecoder("utf-8");
          response.body
            .getReader()
            .read()
            .then(({ value, done }) => {
              systemMessage = decoder.decode(value);
              systemMessage = JSON.parse(systemMessage).Announcement;
              if (systemMessage !== "") {
                this.setState({ systemMessage });
              }
            });
        })
        .catch((error) => {
          console.log(`${error}`);
        });
    }
  };

  loginHandler = (e) => {
    e.preventDefault();
    this.setState({ fetchOutstanding: true });
    fetch(`${this.context.route}/login.webapi`, {
      method: "POST",
      headers: {
        "Content-Type": "text/plain",
      },
      body: JSON.stringify({
        userName: this.state.email,
        password: this.state.password,
      }),
    })
      .then((response) => response.text())
      .then((result) => {
        this.setState({ fetchOutstanding: false });

        if (result.includes("Token")) {
          let parsedResult = JSON.parse(result);
          parsedResult.password = this.state.password;
          const token = parsedResult.Token;
          if (
            parsedResult.TimeZone === undefined ||
            parsedResult.TimeZone == null ||
            parsedResult.TimeZone === "" ||
            true
          ) {
            console.log("Setting timezone from PC");

            parsedResult.TimeZone =
              Intl.DateTimeFormat().resolvedOptions().timeZone;

            console.log("Your detected timezone is ", parsedResult.TimeZone);
            fetch(`${this.context.route}/updatetimezone.webapi`, {
              method: "POST",
              headers: {
                Token: token,
                "Content-Type": "text/plain",
              },
              body: JSON.stringify({
                TimeZone: parsedResult.TimeZone, // Now sending timezone name like "America/New_York"
              }),
            })
              .then(async (response) => {
                if (response.ok) {
                  return response.json();
                } else if (response.status === 401) {
                  console.log("Authentication error");
                }
              })
              .catch((error) => {
                console.log("Error updating timezone:", error);
              });
          } else {
            console.log("Time zone is already defined:", parsedResult.TimeZone);
          }

          this.props.handleLogin(parsedResult);
        } else {
          result = result.replace("{", "").replace("}", "");
          this.setState({
            loginErrorText: result,
            password: "",
          });
        }
      })
      .catch((error) => {
        this.setState({ fetchOutstanding: false, loginErrorText: `${error}` });
        console.log("error", `${error}`);
      });
  };

  forgotPasswordHandler = (e) => {
    let errorResponse = false;
    e.preventDefault();
    this.setState({ fetchOutstanding: true });
    fetch(`${this.context.route}/forgotpassword.webapi`, {
      method: "POST",
      headers: {
        "Content-Type": "text/plain",
      },
      body: JSON.stringify({
        email: this.state.email,
      }),
    })
      .then((response) => {
        if (response.ok) {
          return response.text();
        } else {
          errorResponse = true;
          return response.text();
        }
      })
      .then((result) => {
        this.setState({ fetchOutstanding: false });

        if (errorResponse) {
          result = result.replace("{", "");
          result = result.replace("}", "");
          this.setState({ loginErrorText: result });
        } else {
          this.setState({
            page: "login",
            successMessage: "Password reset email sent",
            loginErrorText: "",
          });
        }
      })
      .catch((error) => {
        this.setState({
          fetchOutstanding: false,
          forgotPasswordErrorText: error,
        });
        if (
          error
            .toString()
            .includes(
              "SyntaxError: Unexpected token U in JSON at position 1"
            ) ||
          error
            .toString()
            .includes("SyntaxError: JSON Parse error: Expected '}'")
        ) {
          this.setState({ authenticationError: true });
        }
        console.log("error", `${error}`);
      });
  };

  joinDemoHandler = (e) => {
    e.preventDefault();
    this.setState({ fetchOutstanding: true });
    if (this.state.newEmail !== this.state.confirmNewEmail) {
      console.log("emails do not match");
      return this.setState({
        loginErrorText:
          "Emails do not match. Please check that you've spelled everything correctly.",
        fetchOutstanding: false,
      });
    }
    fetch(`${this.context.route}/demosignup.webapi`, {
      method: "POST",
      headers: {
        "Content-Type": "text/plain",
      },
      body: JSON.stringify({
        customerFirstName: this.state.firstName,
        customerLastName: this.state.lastName,
        customerEmail: this.state.newEmail,
        whereDidYouHear: this.state.heard,
      }),
    })
      .then((response) => {
        return response.text().then((result) => {
          return { status: response.status, body: result };
        });
      })
      .then(({ status, body }) => {
        this.setState({ fetchOutstanding: false });

        let parsedResult;
        try {
          parsedResult = JSON.parse(body);
        } catch (e) {
          // If it's not JSON, treat the body as the message
          parsedResult = { message: body };
        }

        if (status === 200) {
          // Success case
          this.setState({
            demoMessage: body.replace("{", "").replace("}", ""),
            demoSignup: false,
            page: "login",
            loginErrorText: "",
            successMessage:
              parsedResult.message ||
              "Demo account created. Please check your email for your password.",
          });
        } else {
          // Error case (non-200 status)
          this.setState({
            loginErrorText:
              parsedResult.message || `Request failed with status ${status}`,
          });
        }
      })
      .catch((error) => {
        this.setState({ fetchOutstanding: false });
        console.log("error", `${error}`);
      });
  };

  render() {
    const { doctorImages, currentImageIndex, imageLoaded } = this.state;

    return (
      <div className="loginPageWrapper">
        <div className="loginLandingPage">
          {/* <img src={Logo} className='Logo loginLogo' stroke='none'/> */}
          <h1 className="caseListLogoText" style={{ marginBottom: 20 }}>
            OCC<span className="caseListLogoTextNormal">English</span>
          </h1>
          <div className="loginCardContainer">
            <div className="loginImageContainer">
              {imageLoaded && doctorImages.length > 0 && (
                <>
                  {doctorImages.map((image, index) => (
                    <img
                      key={index}
                      className={`loginImage ${
                        index === currentImageIndex ? "active" : ""
                      }`}
                      src={image}
                      alt={`Doctor ${index + 1}`}
                    />
                  ))}
                </>
              )}
              {(!imageLoaded || doctorImages.length === 0) && (
                <div className="loginImagePlaceholder">
                  <div className="loginImagePlaceholderText">Loading...</div>
                </div>
              )}
            </div>
            <div className="loginContentWrapper">
              {this.state.page === "login" ? (
                <form
                  className="loginContainer"
                  onSubmit={this.loginHandler}
                  key="loginContainer"
                >
                  <h1 className="loginHeader">Login</h1>
                  <label className="loginLabel">Email</label>
                  <input
                    type="text"
                    autoComplete="email"
                    className="loginInput"
                    required
                    value={this.state.email}
                    onChange={(e) => this.setState({ email: e.target.value })}
                  />
                  <label className="loginLabel">Password</label>
                  <input
                    type="password"
                    autoComplete="password"
                    className="loginInput"
                    required
                    value={this.state.password}
                    onChange={(e) =>
                      this.setState({ password: e.target.value })
                    }
                  />
                  <a
                    className="forgotPasswordText"
                    type="button"
                    onClick={() =>
                      this.setState({
                        page: "forgotPassword",
                        loginErrorText: "",
                        successMessage: "",
                      })
                    }
                  >
                    Forgot Password?
                  </a>
                  {!this.state.fetchOutstanding ? (
                    <div className="loginButtonWrapper">
                      <button
                        className="loginButton"
                        type="button"
                        onClick={() =>
                          this.setState({
                            page: "demoSignup",
                            loginErrorText: "",
                            successMessage: "",
                          })
                        }
                      >
                        Demo Signup
                      </button>
                      <button
                        className="loginButton loginPrimaryButton"
                        type="submit"
                      >
                        Login
                      </button>
                    </div>
                  ) : (
                    <div className="loginButtonLoaderWrapper">
                      <MDSpinner
                        size={35}
                        singleColor={this.context.primaryColor}
                      />
                    </div>
                  )}
                  <a
                    className="loginTermsOfServiceText"
                    type="button"
                    onClick={() =>
                      this.setState({
                        page: "termsOfService",
                        loginErrorText: "",
                        successMessage: "",
                      })
                    }
                  >
                    Terms of Service
                  </a>
                  {this.state.loginErrorText !== "" && (
                    <p className="loginErrorText">
                      {this.state.loginErrorText}
                    </p>
                  )}
                  {this.state.successMessage !== "" && (
                    <p className="loginSuccessText">
                      {this.state.successMessage}
                    </p>
                  )}
                </form>
              ) : this.state.page === "forgotPassword" ? (
                <form
                  className="loginContainer"
                  onSubmit={this.forgotPasswordHandler}
                  key="forgotPasswordContainer"
                >
                  <h1 className="loginHeader">Forgot Password</h1>
                  <label className="loginLabel">Email</label>
                  <input
                    type="text"
                    autoComplete="email"
                    required
                    value={this.state.email}
                    onChange={(e) => this.setState({ email: e.target.value })}
                    className="loginInput"
                  />
                  {!this.state.fetchOutstanding ? (
                    <div className="loginButtonWrapper">
                      <button
                        className="loginButton"
                        type="button"
                        onClick={() =>
                          this.setState({ page: "login", loginErrorText: "" })
                        }
                      >
                        Cancel
                      </button>
                      <button
                        className="loginButton loginPrimaryButton"
                        type="submit"
                      >
                        Reset Password
                      </button>
                    </div>
                  ) : (
                    <div className="loginButtonLoaderWrapper">
                      <MDSpinner
                        size={35}
                        singleColor={this.context.primaryColor}
                      />
                    </div>
                  )}
                  {this.state.loginErrorText !== "" && (
                    <p className="loginErrorText">
                      {this.state.loginErrorText}
                    </p>
                  )}
                </form>
              ) : this.state.page === "demoSignup" ? (
                <form
                  className="loginContainer"
                  onSubmit={this.joinDemoHandler}
                  key="demoSignupContainer"
                >
                  <h1 className="loginHeader">Demo Signup</h1>
                  <label className="loginLabel">First Name</label>
                  <input
                    type="text"
                    autoComplete="given-name"
                    required
                    value={this.state.firstName}
                    onChange={(e) =>
                      this.setState({ firstName: e.target.value })
                    }
                    className="loginInput"
                  />
                  <label className="loginLabel">Last Name</label>
                  <input
                    type="text"
                    autoComplete="family-name"
                    required
                    value={this.state.lastName}
                    onChange={(e) =>
                      this.setState({ lastName: e.target.value })
                    }
                    className="loginInput"
                  />
                  <label className="loginLabel">Email</label>
                  <input
                    type="email"
                    autoComplete="email"
                    required
                    value={this.state.newEmail}
                    onChange={(e) =>
                      this.setState({ newEmail: e.target.value })
                    }
                    className="loginInput"
                  />
                  <label className="loginLabel">Confirm Email</label>
                  <input
                    type="email"
                    autoComplete="email"
                    required
                    value={this.state.confirmNewEmail}
                    onChange={(e) =>
                      this.setState({ confirmNewEmail: e.target.value })
                    }
                    className="loginInput"
                  />
                  <label className="loginLabel">
                    Where did you hear about us?
                  </label>
                  <select
                    type="text"
                    required
                    value={this.state.heard}
                    onChange={(e) => this.setState({ heard: e.target.value })}
                    className="loginSelect"
                  >
                    <option>Google Search</option>
                    <option>Bing Search</option>
                    <option>Facebook</option>
                    <option>Friend</option>
                    <option>Other</option>
                  </select>
                  {!this.state.fetchOutstanding ? (
                    <div className="loginButtonWrapper">
                      <button
                        className="loginButton"
                        type="button"
                        onClick={() =>
                          this.setState({ page: "login", loginErrorText: "" })
                        }
                      >
                        Cancel
                      </button>
                      <button
                        className="loginButton loginPrimaryButton"
                        type="submit"
                      >
                        Join Demo
                      </button>
                    </div>
                  ) : (
                    <div className="loginButtonLoaderWrapper">
                      <MDSpinner
                        size={35}
                        singleColor={this.context.primaryColor}
                      />
                    </div>
                  )}
                  <a
                    className="loginTermsOfServiceText"
                    type="button"
                    onClick={() =>
                      this.setState({
                        page: "termsOfService",
                        loginErrorText: "",
                      })
                    }
                  >
                    Terms of Service
                  </a>
                  {this.state.loginErrorText !== "" && (
                    <p className="loginErrorText">
                      {this.state.loginErrorText}
                    </p>
                  )}
                </form>
              ) : (
                this.state.page === "termsOfService" && (
                  <div
                    className="loginContainer termsOfServiceContainer"
                    initial={true ? null : loginContainerTransition.initial}
                    animate={true ? null : loginContainerTransition.in}
                    exit={true ? null : loginContainerTransition.out}
                    transition={{ duration: pageTransitionDuration }}
                    key="termsOfServiceContainer"
                  >
                    <h1 className="loginHeader">Terms of Service</h1>
                    <FAQText />
                    <button
                      className="loginButton termsOfServiceBackButton loginPrimaryButton"
                      onClick={() =>
                        this.setState({ page: "login", loginErrorText: "" })
                      }
                    >
                      Back
                    </button>
                  </div>
                )
              )}
            </div>
            {this.state.systemMessage !== "" && (
              <div className="loginMessageFooter">
                <p className="loginMessageFooterText">
                  {this.state.systemMessage}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
